import React from 'react'
import { useNavigate } from 'react-router-dom'
import PreventiveWaterQualityCard from './PreventiveWaterQualityCard'
import { useAuthState } from '../../../../../Helper/Context';

export default function PreventiveWaterQualityCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const PreventiveWaterQualityNavigate = (name, screenFlag) => {
        if (name === "PH") {
            navigate(`/waterqualityphservicepage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Chlorine") {
            navigate(`/waterqualitychlorineservicepage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "Turbidity") {
            navigate(`/waterqualityturbidityservicepage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        } else if (name === "E-coli" || name === "TDS") {
            navigate(`/waterqualityecoliservicepage?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}`)
        }
    }
    const navigate = useNavigate()
    return (
        <div className="row  ml-lg-0 ml-0 mr-0">
            <div className="col-12 col-md-6 col-lg-3 mb-2 ">
                <PreventiveWaterQualityCard
                    title="PH"
                    imgPath='./assets/img/ph.png'
                    count={Countdata.WaterQualityPHTotalCount ? Countdata.WaterQualityPHTotalCount : '0'}
                    // navLink='/waterqualityphservicepage'
                    PreventiveWaterQualityNavigate={PreventiveWaterQualityNavigate}
                />
            </div>

            <div className="col-12 col-md-6 col-lg-3 mb-2">
                <PreventiveWaterQualityCard
                    title="Chlorine"
                    imgPath='./assets/img/chlorine.png'
                    count={Countdata.WaterQualityChlorineTotalCount ? Countdata.WaterQualityChlorineTotalCount : '0'}
                    PreventiveWaterQualityNavigate={PreventiveWaterQualityNavigate}

                />
            </div>

            <div className="col-12 col-md-6 col-lg-3 mb-2">
                <PreventiveWaterQualityCard
                    title="Turbidity"
                    imgPath='./assets/img/water-pollution.png'
                    count={Countdata.WaterQualityTurbidityTotalCount ? Countdata.WaterQualityTurbidityTotalCount : '0'}
                    // navLink='/waterqualityturbidityservicepage'
                    PreventiveWaterQualityNavigate={PreventiveWaterQualityNavigate}
                />
            </div>

            <div className="col-12 col-md-6 col-lg-3 mb-2">
                <PreventiveWaterQualityCard
                    title={DashProjectTypeId == '9' ? "TDS" : "E-coli"}
                    imgPath='./assets/img/e-coli.png'
                    count={Countdata.WaterQualityEcoliTotalCount ? Countdata.WaterQualityEcoliTotalCount : '0'}
                    // navLink='/waterqualityecoliservicepage'
                    PreventiveWaterQualityNavigate={PreventiveWaterQualityNavigate}
                />
            </div>
        </div>

    )

}
